import React from 'react';
import { Button, Flex, Spinner, Text } from '@podiumhq/design-system';

import { fullPageCenterContentWrapperStyles } from 'styles';

import { trialButtonStyles } from '../../styles';

export const TrialPaymentButton = ({
  buttonLabel = 'Start free trial',
  isDisabled,
  handleSubmit,
  isSubmitting,
  loadingText = 'Creating Account',
}) => (
  <>
    {isSubmitting && (
      <Flex
        backgroundColor="rgba(0, 0, 0, 0.6)"
        zIndex="100"
        {...fullPageCenterContentWrapperStyles}
      >
        <Flex
          align="center"
          backgroundColor="silver.lightest"
          borderRadius="8px"
          direction="column"
          height="153px"
          justify="center"
          padding="24px"
          width="153px"
        >
          <Spinner size="lg" />
          {loadingText && (
            <Text
              fontSize="sm"
              fontWeight="medium"
              mt="17px"
              textAlign="center"
            >
              {loadingText}
            </Text>
          )}
        </Flex>
      </Flex>
    )}
    <Button
      data-testid="trial-payment-button"
      id="TrialPaymentButton-submit-btn"
      disabled={isDisabled}
      onClick={handleSubmit}
      variant="primary"
      width="100%"
      {...trialButtonStyles}
    >
      {buttonLabel}
    </Button>
  </>
);

export default TrialPaymentButton;
